export default () => {
    if ($('.location-page__main__action-bar').length === 0) {
        return;
    }

    $(document).ready(function () {
        const brochurePopupClassName = "#brochure-request-popup",
            floorPlanPopupClassName = "#floorplan-request-popup",
            brochureRequestClassName = "brochure-request-popup-open",
            floorPlanRequestClassName = "floorplan-request-popup-open",
            localStorageName = "fileRequestFulfilled",
            brochureDownload = $('.brochure-download'),
            floorPlanDownload = $('.floorplan-download'),
            brochureURL = brochureDownload.attr('href');
        let floorplanURLs = [];

        floorPlanDownload.each(function (){
            floorplanURLs.push($(this).attr('href'));
        });

        // Download Brochure on click event.
        $(`.${brochureRequestClassName}`).click(function (e) {
            e.preventDefault();

            if (!localStorage.getItem(localStorageName)) {
                $(brochurePopupClassName).addClass('d-flex');
                $(this).addClass('active'); // Add 'active' class
            } else {
                // Follow link in new tab.
                window.open(brochureDownload.attr('href'), '_blank');
            }
        });

        // Floorplan on click event.
        $(`.${floorPlanRequestClassName}`).click(function (e) {
            if (!localStorage.getItem(localStorageName)) {
                e.preventDefault();
                $(floorPlanPopupClassName).addClass('d-flex');
                $(this).addClass('active');
            }
        });

        // Close brochure/download popups.
        $('.close-btn').click(function (e) {
            e.preventDefault();
            $(brochurePopupClassName).removeClass('d-flex');
            $(floorPlanPopupClassName).removeClass('d-flex');

            // Remove 'active' class if form closed early
            $(`.${floorPlanRequestClassName}`).removeClass('active');
            $(`.${brochureRequestClassName}`).removeClass('active');
        });

        // Handle form submission event.
        $(document).on('formSubmission', function() {
            $(brochurePopupClassName).removeClass('d-flex');
            $(floorPlanPopupClassName).removeClass('d-flex');

            // Brochure.
            brochureDownload.attr("href", brochureURL);

            // Floorplan.
            let activeContainer = $(`.${floorPlanRequestClassName}.active`);
            let activeIndex = -1;

            if (activeContainer.length > 0) {
                activeIndex = $(`.${floorPlanRequestClassName}`).index(activeContainer);
            }

            floorPlanDownload.each(function (index) {
                if (index === activeIndex) {
                    $(this).attr('href', floorplanURLs[index]);
                    if (activeIndex !== -1) {
                        window.open(floorplanURLs[index], '_blank'); // Open link in new tab
                    }
                } else {
                    $(this).attr('href', floorplanURLs[index]);
                }
            });

            // Open brochure link if active
            if ($(`.${brochureRequestClassName}.active`).length > 0) {
                window.open(brochureURL, '_blank');
            }
        });

        // Check if user has registered and change functionality of buttons depending on localstorage
        if (!localStorage.getItem(localStorageName)) {
            // Brochure.
            brochureDownload.removeAttr("href");

            // Floorplan.
            floorPlanDownload.removeAttr("href");
        } else {
            brochureDownload.removeClass(brochureRequestClassName);
            floorPlanDownload.removeClass(floorPlanRequestClassName);
        }
    });
}